// @ts-nocheck
/* eslint-disable react/prop-types */
// LiBRARY
import React from 'react';
import {
	Row,
	Col,
	Table,
	Button,
	Typography,
	Form,
	Drawer,
	DatePicker as AntDatePicker,
	Select,
	Icon,
} from 'antd';
// CUSTOM MODULES
import Expandtable from './expandtable';
import { RegexInput } from 'shared_components/pattern_input';
import fetchRequest from 'services/blood_recipient/blood_recipient';
import fetchPriority, { fetchStatus } from 'services/blood_recipient/blood_product_request';
import PageTitle from 'shared_components/page_title';
import Message from 'shared_components/message';
import SearchPager from 'shared_components/search_pager';
import BloodRequestDetails from '../detail';
import { fetchBloodTypes } from 'services/blood_bank/blood_types';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import moment from 'moment';
import './index.css';

const { Text } = Typography;
const { Option } = Select;

const columns = [
	{
		title: "PATIENT'S ID",
		dataIndex: 'recipient_id',
		width: 100,
		fixed: 'left',
	},
	{
		title: 'LAST NAME',
		dataIndex: 'last_name',
		width: 150,
		fixed: 'left',
	},
	{
		title: 'FIRST NAME',
		dataIndex: 'first_name',
		width: 150,
	},
	{
		title: 'MIDDLE NAME',
		dataIndex: 'middle_name',
		width: 150,
	},
	{
		title: 'GENDER',
		dataIndex: 'gender',
		width: 80,
	},
	{
		title: 'DATE OF BIRTH',
		dataIndex: 'birth_date',
		width: 120,
	},
	{
		title: 'ADDRESS',
		render: record =>
			`${record.address_line_1} ${record.address_line_2} ${record.barangay_name} ${record.city_name} ${record.province_name}`,
		width: 400,
	},
	{
		title: 'BLOOD TYPE',
		dataIndex: 'blood_type',
		width: 120,
		fixed: 'right',
	},
];

class BloodRequestSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			loading: false,
			displayDrawer: false,
			pageSize: GLOBAL_TABLE_PAGE_SIZE,
			selectedDateValue: moment().format('YYYYMMDD'),
			selectedRequest: {},
			drawerTitle: '',
			drawerButton: '',
			disableButton: false,
			bloodType: [],
			actionType: null,
			buttons: true,
			status: [],
			priority: [],
		};
		this.formRef = React.createRef();
	}
	// For Dropdown Parameters
	async componentDidMount() {
		const StatusList = await fetchStatus();
		const bloodTypeList = await fetchBloodTypes();
		const PriorityList = await fetchPriority();

		this.setState({
			// loading: true,
			bloodType: bloodTypeList,
			status: StatusList,
			priority: PriorityList,
		});
	}

	// Fetch All Data in Form And Pass in API to Search must be accept undefined
	handleSubmit = async value => {
		const { dateString } = this.state;
		const payload = { ...value, requested_date: dateString };

		this.setState({ loading: true });

		const patients = await fetchRequest(payload);
		console.log(patients.results);

		this.setState({
			loading: false,
			data: patients.results,
			// actionType: (patientName === '') ? 'byID' : 'byName'
		});

		if (patients.length <= 0) Message.info('No results found');
	};

	handleChangeSize = pageSize => {
		this.setState({ pageSize });
	};

	onChange = (date, dateString) => {
		this.setState({ dateString });
	};

	onDisable = () => {
		this.setState({
			buttons: false,
		});
	};

	onCloseDrawer = () => {
		this.setState({ displayDrawer: false });
	};

	redirect = () => {
		this.props.history.push('/bloodbank/blood_request/create');
	};

	displayDrawerAdd = record => {
		this.setState({
			displayDrawer: true,
			drawerTitle: 'ADD REQUEST',
			drawerButton: 'ADD',
			disableButton: false,
			selectedRequest: record,
			action: 'ADD',
		});
	};

	displayDrawerUpdate = record => {
		this.setState({
			displayDrawer: true,
			drawerTitle: 'REQUEST DETAILS',
			drawerButton: 'UPDATE REQUEST',
			disableButton: true,
			selectedRequest: record,
			action: 'UPDATE',
		});
	};

	clearInputs = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({
			patientID: '',
			patientName: '',
			Date: '',
			blood_type: '',
			status: '',
			priority: '',
		});
		this.setState({ data: [] });
	};

	render() {
		const {
			data,
			action,
			status,
			buttons,
			loading,
			priority,
			pageSize,
			bloodType,
			drawerTitle,
			drawerButton,
			disableButton,
			displayDrawer,
			selectedRequest,
			// actionType
		} = this.state;

		const BloodTypeOptions = bloodType.map(item => (
			<Option key={item.blood_type_id} value={item.blood_type}>
				{item.blood_type}
			</Option>
		));

		const StatusOptions = status.map(item => (
			<Option key={item.status_id} value={item.status_name}>
				{item.status_name}
			</Option>
		));

		const PriorityOptions = priority.map(item => (
			<Option key={item.priority_id} value={item.priority_name}>
				{item.status_name}
			</Option>
		));

		const TableData = data.map((currElement, index, array) => ({
			...currElement,
			key: index,
		}));

		return (
			<div>
				<PageTitle pageTitle="BLOOD REQUEST" />
				<div className="space-y-md"></div>
				<Form
					className="blood-request-search-patient-form"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					layout="vertical"
				>
					<div className="container">
						<Col className="patient-id">
							<Form.Item label="ID" name="patientID">
								<RegexInput
									regex={/[A-Za-z0-9, -]/}
									maxLength={100}
									onChange={this.onDisable}
									placeholder="Patient's ID"
								/>
							</Form.Item>
						</Col>
						<p className="font-md leading-none text" style={{ marginBottom: 8 }}>
							OR
						</p>
						<Col className="patient-name">
							<Form.Item label="NAME" name="patientName">
								<RegexInput
									regex={/[A-Za-z0-9, -]/}
									maxLength={100}
									onChange={this.onDisable}
									placeholder="Patient's Name"
								/>
							</Form.Item>
						</Col>
						<Col className="date">
							<Form.Item label="SELECT DATE" name="Date">
								<AntDatePicker onChange={this.onChange} style={{ width: '100%' }} />
							</Form.Item>
						</Col>
					</div>
					<div className="container" style={{ marginTop: 20 }}>
						<Col className="blood-type">
							<Form.Item name="blood_type" label="BLOOD TYPE">
								<Select onChange={this.onDisable} allowClear>
									{BloodTypeOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col className="status">
							<Form.Item name="status" label="STATUS">
								<Select onChange={this.onDisable} allowClear>
									{StatusOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col className="priority">
							<Form.Item name="priority" label="PRIORITY">
								<Select onChange={this.onDisable} allowClear>
									{PriorityOptions}
								</Select>
							</Form.Item>
						</Col>
						<div className="buttons">
							<Button
								className="form-button"
								shape="round"
								style={{ width: 120 }}
								onClick={this.clearInputs}
							>
								CLEAR
							</Button>
							<Button
								loading={loading}
								className="form-button"
								shape="round"
								type="primary"
								htmlType="submit"
								style={{ width: 120 }}
								disabled={buttons}
							>
								SEARCH
							</Button>
						</div>
					</div>
				</Form>
				<div className="space-y-md"></div>
				<Col span={24}>
					{/* <Button
              type="primary"
              shape="round"
              onClick={this.displayDrawerAdd}
              style={{
                marginLeft: "79%",
                position: "absolute",
                zIndex: 99,
                marginTop: 15,
              }}
            >
              ADD REQUEST
            </Button> */}
					<SearchPager
						handleChangeSize={this.handleChangeSize}
						pageTotal={data.length}
						pageSize={pageSize}
					/>
				</Col>
				<div className="space-y-sm"></div>
				<Table
					style={{ textTransform: 'uppercase' }}
					dataSource={TableData}
					pagination={{ pageSize }}
					loading={loading}
					columns={columns}
					expandable={{
						expandedRowRender: record => <Expandtable record={record} />,
					}}
					onRow={record => {
						return {
							onDoubleClick: () => {
								this.displayDrawerAdd(record);
							},
						};
					}}
					scroll={{ x: '1500px' }}
					// {...(actionType === 'byName' && {footer: () => TableFooter})}
				/>
				<Drawer
					title={drawerTitle}
					width="60%"
					visible={displayDrawer}
					onClose={this.onCloseDrawer}
					destroyOnClose
				>
					<BloodRequestDetails
						selectedRequest={selectedRequest}
						onClose={this.onCloseDrawer}
						drawerButton={drawerButton}
						disableButton={disableButton}
						action={action}
					/>
				</Drawer>
			</div>
		);
	}
}

export default BloodRequestSearch;
